module.exports = __webpack_public_path__ + "img/1类爆炸.8d6d7581.png";